<button mat-mini-fab color="secondary" (click.stopp)="vedLukk.emit()" class="lukk" data-testid="lukk">
  <mat-icon>close</mat-icon>
</button>

@if (visFilnavn()) {
  <div class="filnavn">{{ dokumentversjon().pdfFilnavn }}</div>
}

@if (stotterPdfJs) {
  <dokument-vis-pdf-iframe [dokumentversjon]="dokumentversjon()" [forespurtAnnoteringId]="forespurtAnnoteringId()"/>

} @else {
  <inline-melding type="advarsel">
    {{ 'Benytt en nyere nettleser for å annotere og se kommentarer til dokumentet'|translate }}
  </inline-melding>
  <iframe [src]="dokumentUrl()"></iframe>
}
